import "../itinerary.css"
import { yupResolver } from "@hookform/resolvers";
import Decimal from "decimal.js";
import React, { useContext, useEffect, useState, useRef } from "react";
import { Col, Form, Button, Row, Spinner, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { WidgetContext } from "../../../../../../context/WidgetContext";
import Quote from "../../../../../../Data/Quote/Quote";
import { PaymentAllocationCategory } from "../../../../../../Data/Reservation/PaymentAllocationCategory";
import { ReservationCustomer } from "../../../../../../Data/Reservation/ReservationCustomer";
import { Constants } from "../../../../../../_helpers/Constants";
import { NormalizeCurrencyInput, isStringEmpty } from "../../../../../../_helpers/Functions";
import useFetch, { FetchRequest } from "../../../../../../_helpers/UseFetchHook";
import Checkbox from "../../../assets/check-box/CheckBox";
import useGetGlacierCompanyToken from "../../data-service-hooks/UseGetGlacierCompanyByResOrCompanyIdToken";
import useGetGlacierCustomer from "../../data-service-hooks/UseGetGlacierCustomer";
import { MakePaymentFormData, MakePaymentSchema, MakePaymentSchemaDefaultValues } from "../../widget-modals/schemas/MakePaymentScheme";
import parse from 'html-react-parser';
import ViewPort from "../../../../../../_helpers/Enums/ViewPortEnum";
import ReCAPTCHA from "react-google-recaptcha";
import useValidateReCaptcha, { ValidateReCaptchaRequest } from "../../data-service-hooks/UseValidateReCaptcha";
import StartWidgetBrandSetting from "../../../../../../Data/StartWidgetBrandSetting";

interface props {
  // itinerary: Itinerary;
  quote: Quote;
  payingCustomer: ReservationCustomer | undefined;
  onPaymentMade: (data: any) => void;
  onError: (error: any) => void;
}

export interface GlacierCustomer {
  billingFirstName: string,
  billingLastName: string,
  billingAddress: string,
  billingCity: string,
  billingState: string,
  billingZip: string,
  billingCountry: string,
  billingEmail: string,
  paymentToken?: string,
  ccType?: string,
  ccNumber?: string,
  ccExpiration?: string,
}

const MakePayment: React.FC<props> = (props) => {
  const { datesAndGuests, /* brandId */brand, brandSettings, viewPortBreakPoint } = useContext(WidgetContext);

  const { quote } = props;

  const [payingCustomer, setPayingCustomer] = useState<ReservationCustomer | undefined>(props.payingCustomer);
  // const [customerPayments, setCustomerPayments] = useState<any[]>([]);
  const brandSetting: StartWidgetBrandSetting = brandSettings.find(s => s.brandId === brand?.brandId) as StartWidgetBrandSetting;

  const [paymentOption, setPaymentOption] = useState<string>("split");
  let _paymentOption: string = "split";

  const [fetchGlacierTokenRequest, setGlacierTokenRequest] = useState<any>();
  const fetchGlacierTokenResponse = useGetGlacierCompanyToken(fetchGlacierTokenRequest);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [glacierToken, setGlacierToken] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const [fetchGlacierCustomerRequest, setGlacierCustomerRequest] = useState<any>();
  const fetchGlacierCustomerResponse = useGetGlacierCustomer(fetchGlacierCustomerRequest);
  const [glacierCustomer, setGlacierCustomer] = useState<GlacierCustomer | null>(null);
  const [submitPaymentRequest, setSubmitPaymentRequest] = useState<FetchRequest>();
  const submitPaymentResponse = useFetch(submitPaymentRequest);
  const [paymentErrors, setPaymentErrors] = useState<any[]>([]);

  const [submitted, setSubmitted] = useState(false);
  const [ccnumberInvalid, setCCNumberInvalid] = useState(false);
  const [ccNumberValidated, setccNumberValidated] = useState(false);
  const [ccnumberInvalidFeedback, setCCNumberInvalidFeedback] = useState<string | null>(null);
  const [ccexpInvalid, setCCExpInvalid] = useState(false);
  const [ccExpValidated, setccExpValidated] = useState(false);
  const [ccexpInvalidFeedback, setCCExpInvalidFeedback] = useState<string | null>(null);
  const [cvvInvalid, setCVVInvalid] = useState(false);
  const [cvvValidated, setCVVValidated] = useState(false);
  const [cvvInvalidFeedback, setCVVInvalidFeedback] = useState<string | null>(null);

  const [validateReCaptchaRequest, setValidateReCaptchaRequest] = useState<ValidateReCaptchaRequest | null>(null);
  const validateReCaptchaResponse = useValidateReCaptcha(validateReCaptchaRequest);
  const captchaRef = useRef<any>(null);
  const [captcha, setCaptcha] = useState<string | null>(null);

  const itinerary = {
    lodgingItineraries: quote.reservation.lodgingItineraries,
    golfItineraries: quote.reservation.golfItineraries,
    transportItineraries: quote.reservation.transportItineraries,
    customItineraries: quote.reservation.customItineraries,
    adjustments: quote.reservation.adjustments
  }

  const paymentAllocations: PaymentAllocationCategory[] = quote.reservation.paymentCategories ? quote.reservation.paymentCategories : [];
  const hasAllocations = paymentAllocations.length > 0;

  const balanceDue = new Decimal(quote.reservation.balanceDue ? quote.reservation.balanceDue : 0.0).toDecimalPlaces(2).toNumber();
  const totalSell = new Decimal(quote.reservation.totalSell ? quote.reservation.totalSell : 0.0).toDecimalPlaces(2).toNumber();

  const evenCategory = paymentAllocations.find(a => a.categoryName === "Even Split");
  const evenPersonsToDivideBy = quote.reservation.numGuests - PaymentAllocationCategory.getTotalAllocationLines(paymentAllocations);

  const priceMinusCategories = new Decimal(totalSell - PaymentAllocationCategory.getTotalAllocationsCost(paymentAllocations, itinerary, quote.reservation.numGuests - quote.reservation.reservationCustomers.filter(c => c.cancelled).length)).toDecimalPlaces(2).toNumber();
  const evenPerPersonPrice = new Decimal(priceMinusCategories).dividedBy(evenPersonsToDivideBy === 0 ? 1 : evenPersonsToDivideBy).toDecimalPlaces(2).toNumber();

  const [fullPaymentPrice, setFullPaymentPrice] = useState(0.0);
  const [splitPaymentPrice, setSplitPaymentPrice] = useState(0.0); // if customer has allocation use that else if even split defined, use that, else reservation balanceDue
  const [depositPrice, setDepositPrice] = useState<number>(0.0);
  const [paymentsMadeTotal, setPaymentsMadeTotal] = useState<number>(0);
  const [selectedCustomerPaymentsAmount, setSelectedCustomerPaymentsAmount] = useState<number>(0);

  const [agentTip, setAgentTip] = useState<string>("0.00");
  const [paymentAmount, setPaymentAmount] = useState<number>(0);

  const [showTerms, setShowTerms] = useState<boolean>();

  const { register, handleSubmit, errors, formState, setValue, reset, getValues } = useForm<MakePaymentFormData>({
    mode: "onBlur",
    resolver: yupResolver(MakePaymentSchema),
    defaultValues: MakePaymentSchemaDefaultValues
  });

  const _setPaymentOption = (option: string) => {
    setPaymentOption(option);

    const tip = NormalizeCurrencyInput(agentTip);
    setPaymentAmount(option === "split" ? splitPaymentPrice + +tip : (option === "full" ? fullPaymentPrice + +tip : depositPrice + +tip));
  }

  const onAgentTip = (event: any) => {
    const value = event.currentTarget.value;
    if (!value) {
      // setAgentTip("0.00");
      return;
    }

    const tip = NormalizeCurrencyInput(value);
    const payment = paymentOption === "full" ? fullPaymentPrice : (paymentOption === "split" ? splitPaymentPrice : depositPrice);
    setAgentTip(tip);
    // setAgentTip(new Decimal(value).toDecimalPlaces(2).toNumber());
    setPaymentAmount(payment + +tip);
  }

  useEffect(() => {
    const payments = quote.reservation.payments ? quote.reservation.payments : [];
    const paymentsAmount = payments.reduce(function (acc, obj) { return new Decimal(acc).add(obj.paymentAmount).toNumber(); }, 0);
    const tipsAmount = payments.reduce(function (acc, obj) { return new Decimal(acc).add(obj.tipAmount).toNumber(); }, 0);

    setPaymentsMadeTotal(paymentsAmount - tipsAmount);
  }, [quote]);

  useEffect(() => {
    if (payingCustomer) {
      setGlacierCustomerRequest(payingCustomer);
      setGlacierTokenRequest(payingCustomer);

      if (payingCustomer.customerId === quote.reservation.leadCustomerId) {
        _setPaymentOption("full");
        _paymentOption = "full";
      }
      else if (paymentAllocations.length > 0) {
        _setPaymentOption("split");
        _paymentOption = "split";
      }
      else {
        _setPaymentOption("full");
        _paymentOption = "full";
      }

      //set customer payments history
      const payments = quote.reservation.payments;
      const custPayments = payments ? payments.filter(p => p.customerId === payingCustomer.customerId) : []

      let customerPaymentsAmount = (custPayments.filter(p => p.status === null || p.status === undefined || p.status == "Complete" || p.status == "Pending" || p.paymentTypeId === 20)
        .reduce(function (acc, obj) { return new Decimal(acc).add(obj.paymentAmount).toNumber(); }, 0));
      const customerTipsAmount = (custPayments.filter(p => p.status === null || p.status === undefined || p.status == "Complete" || p.status == "Pending" || p.paymentTypeId === 20)
        .reduce(function (acc, obj) { return new Decimal(acc).add(obj.tipAmount).toNumber(); }, 0));
      customerPaymentsAmount -= customerTipsAmount;

      setSelectedCustomerPaymentsAmount(customerPaymentsAmount);

      let price = 0.0;
      if ((payingCustomer.paymentAllocationCategory === null || payingCustomer.paymentAllocationCategory === undefined))
        price = evenCategory === undefined ? balanceDue : evenPerPersonPrice;
      else {
        if (evenCategory !== undefined && payingCustomer.paymentAllocationCategoryId === evenCategory.paymentAllocationCategoryId) price = evenPerPersonPrice;
        else price = PaymentAllocationCategory.getCost(payingCustomer.paymentAllocationCategory, itinerary, quote.reservation.numGuests - quote.reservation.reservationCustomers.filter(c => c.cancelled).length);
      }

      const totalSell = quote.reservation.totalSell as number;
      const fullPrice = quote.reservation.balanceDue !== undefined ? quote.reservation.balanceDue : 0.0;
      let deposit = 0.0;

      setFullPaymentPrice(fullPrice);
      setSplitPaymentPrice(price - customerPaymentsAmount);

      if (props.payingCustomer === undefined) {
        deposit = brandSetting.downPaymentType === "$" ? brandSetting.downPayment : (((brandSetting.downPayment / 100) * totalSell) - customerPaymentsAmount);
      }
      else {
        deposit = brandSetting.downPaymentType === "$" ? brandSetting.downPayment : (((brandSetting.downPayment / 100) * price)) - customerPaymentsAmount;
      }

      setDepositPrice(deposit);

      setPaymentAmount(_paymentOption === "split" ? price - customerPaymentsAmount : (_paymentOption === "full" ? fullPrice : deposit));
    } else {
      setPayingCustomer(quote.reservation.reservationCustomers[0]);
    }
  }, [payingCustomer]);

  useEffect(() => {
    if (fetchGlacierCustomerResponse.data) {
      setGlacierCustomer(fetchGlacierCustomerResponse.data);
    }
  }, [fetchGlacierCustomerResponse.data]);

  useEffect(() => {
    if (fetchGlacierTokenResponse.data) {
      setGlacierToken((fetchGlacierTokenResponse.data as any).token);
    }
  }, [fetchGlacierTokenResponse.data]);

  useEffect(() => {
    if (fetchGlacierTokenResponse.error) {
      console.log("glacier fetch error", fetchGlacierTokenResponse.error);
    }
  }, [fetchGlacierTokenResponse.error]);

  useEffect(() => {
    if (glacierToken) {
      // Add the js script.
      setIsLoading(true);
      //outputIsBusy(true);

      const existingScript = document.getElementById('glacier');
      if (!!existingScript) {
        existingScript.remove();
      }
      const script = document.createElement('script');
      script.src = 'https://secure.glacierpaygateway.com/token/Collect.js';
      script.id = 'glacier';
      script.setAttribute('data-tokenization-key', glacierToken);
      document.body.appendChild(script);
      script.onload = () => {
        configureGlacier();
      };
    }
  }, [glacierToken]);

  useEffect(() => {
    if (glacierCustomer && !isStringEmpty(glacierCustomer.paymentToken)) {
      setSubmitPaymentRequest({
        url: `${Constants.apiUrl}/api/v1.0/customer/${payingCustomer && payingCustomer.customerId}/pay/${payingCustomer && payingCustomer.reservationId}/payments`,
        method: 'POST',
        body: { ...glacierCustomer, billingPrice: +(paymentAmount.toFixed(2)), tipAmount: +agentTip }
      });
    };
  }, [glacierCustomer && glacierCustomer.paymentToken]);

  useEffect(() => {
    _paymentOption = paymentOption;
  }, [paymentOption]);

  const submitForm = (formData: any) => {
    // make the call to verify the captcha
    if (captchaRef !== null && captchaRef.current !== null) {
      // const token = formData["g-recaptcha-response"];
      const token = captchaRef.current.getValue();
      if (!isStringEmpty(token))
        setValidateReCaptchaRequest({ token });
    }
  }

  useEffect(() => {
    if (validateReCaptchaResponse.data === null) return;

    if (validateReCaptchaResponse.data.success) submitPayment();
    else captchaRef.current.reset();

    setValidateReCaptchaRequest(null);

  }, [validateReCaptchaResponse.data]);

  const submitPayment = () => {
    if (ccNumberValidated && ccExpValidated && cvvValidated) {
      // Submit the form.
      setSubmitted(false);
      setSubmitting(true);
      //outputIsBusy(true);
      (window as any).CollectJS.startPaymentRequest();
    }
    else {
      setCCNumberInvalid(ccNumberValidated);
      setCCExpInvalid(ccExpValidated);
      setCVVInvalid(cvvValidated);
    }
  }

  const configureGlacier = () => {
    (window as any).CollectJS.configure({
      'variant': 'inline',
      'paymentType': 'cc',
      'customCss': {
        'font-family': 'sans-serif',
        'padding-left': '10px',
        'font-color': "red"
      },
      'fields': {
        'ccnumber': {
          'selector': '#ccnumber',
          'placeholder': 'Card Number'
        },
        'ccexp': {
          'selector': '#ccexp',
          'placeholder': 'Expiry'
        },
        'cvv': {
          'display': 'required',
          'selector': '#cvv',
          'placeholder': 'CVV'
        },
      },
      'validationCallback': (field: any, valid: boolean, message: any) => {
        if (!valid) {
          setSubmitted(false);
          setSubmitting(false);
          // outputIsBusy(false);
          // outputToken(null);
        }

        validationCallback(field, valid, message);
      },
      'timeoutDuration': 5000,
      'timeoutCallback': () => {
        clearAllValidation();
        console.log("The tokenization didn't respond in the expected timeframe.  This could be due to an invalid or incomplete field or poor connectivity");
      },
      'fieldsAvailableCallback': () => {
        setIsLoading(false);
        // outputIsBusy(false);
      },
      'callback': (response: any) => {
        setSubmitting(false);
        // outputIsBusy(false);
        setSubmitted(true);
        // outputToken(response.token);
        setGlacierCustomer({
          billingFirstName: `${getValues("billingFirstName")}`,
          billingLastName: `${getValues("billingLastName")}`,
          billingAddress: getValues("billingAddress"),
          billingCity: getValues("billingCity"),
          billingState: getValues("billingState"),
          billingZip: getValues("billingZip"),
          billingCountry: getValues("billingCountry"),
          billingEmail: getValues("billingEmail"),
          paymentToken: response.token
        });
      }
    });
  }

  const clearAllValidation = () => {
    setCCNumberInvalid(true);
    setccNumberValidated(false);
    setCCNumberInvalidFeedback(null);
    setCCExpInvalid(true);
    setccExpValidated(false);
    setCCExpInvalidFeedback(null);
    setCVVInvalid(true);
    setCVVValidated(false);
    setCVVInvalidFeedback(null);
  }

  const setValidated = (field: string) => {
    if (field == 'ccnumber') {
      setccNumberValidated(true);
      setCCNumberInvalid(false);
      setCCNumberInvalidFeedback(null);
    }
    if (field == 'ccexp') {
      setccExpValidated(true);
      setCCExpInvalid(false);
      setCCExpInvalidFeedback(null);
    }
    if (field == 'cvv') {
      setCVVValidated(true);
      setCVVInvalid(false);
      setCVVInvalidFeedback(null);
    }
  }

  const validationCallback = (field: any, valid: boolean, message: any) => {
    if (valid) {
      setValidated(field);
      return;
    }

    if (field == "ccnumber") {
      setccNumberValidated(false);
      setCCNumberInvalid(true);
      // setCCNumberInvalidFeedback(message);
      setCCNumberInvalidFeedback("Required");
    } else if (field == "ccexp") {
      setccExpValidated(false);
      setCCExpInvalid(true);
      // setCCExpInvalidFeedback(message);
      setCCExpInvalidFeedback("Required");
    } else if (field == "cvv") {
      setCVVValidated(false);
      setCVVInvalid(true);
      // setCVVInvalidFeedback(message);
      setCVVInvalidFeedback("Required");
    }
  }

  const customerSelected = (event: any) => {
    setPayingCustomer(quote.reservation.reservationCustomers.find(rc => rc.customerId == event.target.value));
  }

  const paymentOptionChanged = (event: any) => {
    _setPaymentOption(event.target.value);
  }

  // function getFullPaymentSpaces() {
  //   const spaceCount = viewPortBreakPoint < ViewPort.lg ? 30 : 37;
  //   const space = "\xa0";
  //   const priceString = paymentAmount.toFixed(2);
  //   const splitString = priceString.split(".");
  //   const charCount = splitString[0].length;
  //   return space.repeat(spaceCount - charCount);
  // }

  // function getSplitPaymentSpaces() {
  //   const spaceCount = viewPortBreakPoint < ViewPort.lg ? 29 : 36;
  //   const space = "\xa0";
  //   const priceString = paymentAmount.toFixed(2);
  //   const splitString = priceString.split(".");
  //   const charCount = splitString[0].length;
  //   return space.repeat(spaceCount - charCount);
  // }

  // function getDepositPaymentSpaces() {
  //   const spaceCount = viewPortBreakPoint < ViewPort.lg ? 29 : 37;
  //   const space = "\xa0";
  //   const priceString = paymentAmount.toFixed(2);
  //   const splitString = priceString.split(".");
  //   const charCount = splitString[0].length;
  //   return space.repeat(spaceCount - charCount);
  // }

  function parseTerms(): any {
    let data = brandSetting.brand.termsAndConditions;

    const tags = {
      "<COMPANY>": brandSetting.brand.company.companyName,
      "<COMPANYPHONE>": brandSetting.brand.company.phone,
      "<BRAND>": brandSetting.brand.brandName,
      "<BRANDPHONE>": brandSetting.brand.phone,
      "&lt;COMPANY&gt;": brandSetting.brand.company.companyName,
      "&lt;COMPANYPHONE&gt;": brandSetting.brand.company.phone,
      "&lt;BRAND&gt;": brandSetting.brand.brandName,
      "&lt;BRANDPHONE&gt;": brandSetting.brand.phone,
    }

    for (const [key, value] of Object.entries(tags)) {
      // console.log(`${key}: ${value}`);
      const rgx = new RegExp(key, 'g');
      if (value !== undefined && value !== null) {
        data = data.replace(rgx, value.toString());
      }
    }

    return parse(data);
  }

  useEffect(() => {
    // console.log("payment response", submitPaymentResponse);
    if (submitPaymentResponse.data) {
      captchaRef.current.reset();
      // console.log("payment response data", submitPaymentResponse.data);
      if (submitPaymentResponse.data.success && payingCustomer != undefined) {
        props.onPaymentMade({ customerId: payingCustomer.customerId, amount: paymentAmount, tipAmount: +agentTip, statusId: submitPaymentResponse.data.reservationStatus });
      } else {
        props.onError({ error: submitPaymentResponse.data.message });
      }
    }
  }, [submitPaymentResponse.data]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0)
      console.log("form errors", errors);
  }, [errors]);

  return (
    <React.Fragment>
      <Col className="">
        {/* Itinerary Info */}
        {/* Desktop */}
        {/* <div className="d-none d-lg-block grey-bottom-border">
          <Col xs={12} className="d-flex flex-row justify-content-between m-0 p-0">
            <h4 className="bold-text m-0 p-0">Itinerary# {quote.reservation.itineraryNumber}</h4>
            <p className="itinerary-info m-0 p-0 mr-5"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.fromDate ? datesAndGuests.fromDate.toDateString() : "Arrive"}</p>
            <p className="itinerary-info m-0 p-0 mr-5"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.toDate ? datesAndGuests.toDate.toDateString() : "Depart"}</p>
            <p className="itinerary-info m-0 p-0"><span className="font-weight-bold">{datesAndGuests.guests}</span>{` Guest${datesAndGuests.guests > 1 ? "s" : ""}`}</p>
          </Col>
        </div> */}
        {/* Itinerary Info */}
        {/* Mobile */}
        {/* <div className="d-lg-none grey-bottom-border">
          <Col>
            <h4 className="bold-text m-0 p-0">Itinerary# {quote.reservation.itineraryNumber}</h4>
            <Col className="d-flex flex-row move-left">
              <Col xs={5}>
                <p className="itinerary-info m-0 p-0 mr-5"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.fromDate ? datesAndGuests.fromDate.toDateString() : "Arrive"}</p>
              </Col>
              <Col xs={5}>
                <p className="itinerary-info m-0 p-0 mr-5"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.toDate ? datesAndGuests.toDate.toDateString() : "Depart"}</p>
              </Col>
              <Col xs={2}>
                <p className="itinerary-info m-0 p-0"><span className="font-weight-bold">{datesAndGuests.guests}</span>{` Guest${datesAndGuests.guests > 1 ? "s" : ""}`}</p>
              </Col>
            </Col>
          </Col>
        </div> */}

        {/* Billing Info */}
        <Col style={{ marginTop: "0px" }}>
          <h4>Billing Info</h4>
        </Col>
      </Col>

      <Form className="widget-font" noValidate onSubmit={handleSubmit(submitForm)}>
        <Form.Row>
          <Col xs={12} lg={6}>
            {/* <Form.Label className="add-golf-label">First Name</Form.Label> */}
            <Form.Control className="box-shadow"
              name="billingFirstName"
              placeholder="First Name"
              ref={register}
              isValid={formState.isSubmitted && !errors.billingFirstName}
              isInvalid={formState.isSubmitted && (!!errors.billingFirstName)}
            />

            <Form.Control.Feedback type="invalid">
              {errors.billingFirstName && errors.billingFirstName.message}
            </Form.Control.Feedback>
          </Col>
          <Col xs={12} lg={6} className="mt-2 mt-lg-0">
            {/* <Form.Label className="add-golf-label">Last Name</Form.Label> */}
            <Form.Control className="box-shadow"
              name="billingLastName"
              placeholder="Last Name"
              ref={register}
              isValid={formState.isSubmitted && !errors.billingLastName}
              isInvalid={formState.isSubmitted && (!!errors.billingLastName)}
            />

            <Form.Control.Feedback type="invalid">
              {errors.billingLastName && errors.billingLastName.message}
            </Form.Control.Feedback>
          </Col>
        </Form.Row>

        <Form.Row>
          <Col xs={12} lg={6} className="mt-2 mt-lg-3">
            <Form.Control className="box-shadow"
              name="billingAddress"
              placeholder="Billing Address"
              ref={register}
              isValid={formState.isSubmitted && !errors.billingAddress}
              isInvalid={formState.isSubmitted && (!!errors.billingAddress)}
            />

            <Form.Control.Feedback type="invalid">
              {errors.billingAddress && errors.billingAddress.message}
            </Form.Control.Feedback>
          </Col>
          <Col xs={6} lg={3} className="mt-2 mt-lg-3">
            <Form.Control className="box-shadow"
              name="billingCity"
              placeholder="City"
              ref={register}
              isValid={formState.isSubmitted && !errors.billingCity}
              isInvalid={formState.isSubmitted && (!!errors.billingCity)}
            />

            <Form.Control.Feedback type="invalid">
              {errors.billingCity && errors.billingCity.message}
            </Form.Control.Feedback>
          </Col>
          <Col xs={6} lg={3} className="mt-2 mt-lg-3">
            {/* <Form.Label className="add-golf-label">State</Form.Label> */}
            <Form.Control className="box-shadow"
              name="billingState"
              placeholder="State/Province"
              ref={register}
              isValid={formState.isSubmitted && !errors.billingState}
              isInvalid={formState.isSubmitted && (!!errors.billingState)}
            />

            <Form.Control.Feedback type="invalid">
              {errors.billingState && errors.billingState.message}
            </Form.Control.Feedback>
          </Col>
        </Form.Row>

        <Form.Row>
          <Col xs={6} lg={3} className="mt-2 mt-lg-3">
            {/* <Form.Label className="add-golf-label">Country</Form.Label> */}
            <Form.Control className="box-shadow"
              name="billingCountry"
              placeholder="Country"
              ref={register}
              isValid={formState.isSubmitted && !errors.billingCountry}
              isInvalid={formState.isSubmitted && (!!errors.billingCountry)}
            />

            <Form.Control.Feedback type="invalid">
              {errors.billingCountry && errors.billingCountry.message}
            </Form.Control.Feedback>
          </Col>
          <Col xs={6} lg={3} className="mt-2 mt-lg-3">
            {/* <Form.Label className="add-golf-label">Postal Code</Form.Label> */}
            <Form.Control className="box-shadow"
              name="billingZip"
              placeholder="Post/Zip Code"
              ref={register}
              isValid={formState.isSubmitted && !errors.billingZip}
              isInvalid={formState.isSubmitted && (!!errors.billingZip)}
            />

            <Form.Control.Feedback type="invalid">
              {errors.billingZip && errors.billingZip.message}
            </Form.Control.Feedback>
          </Col>
          <Col xs={12} lg={6} className="mt-2 mt-lg-3">
            {/* <Form.Label className="add-golf-label">Email</Form.Label> */}
            <Form.Control className="box-shadow"
              name="billingEmail"
              placeholder="Email Address"
              ref={register}
              isValid={formState.isSubmitted && !errors.billingEmail}
              isInvalid={formState.isSubmitted && (!!errors.billingEmail)}
            />

            <Form.Control.Feedback type="invalid">
              {errors.billingEmail && errors.billingEmail.message}
            </Form.Control.Feedback>
          </Col>
        </Form.Row>

        <Col className="grey-bottom-border" style={{ marginTop: "20px" }} />

        <div className="w-100 mt-3">
          <Row>
            <Col xs={12} lg={6} className="pr-0 pr-lg-4">
              {/* Payment Info Form */}
              <img style={{ marginTop: "-2px" }} alt="Credit Card Logos" title="Credit Card Logos" src="https://pkgloop.com/wp-content/uploads/2022/02/cusrtom-cc-card-logos-merged-3-no-cards.png" />
              <Form.Row className="mt-1">
                <Form.Group as={Col} xs={12} lg={6} controlId="ccnumber" className="ccnumber">
                  {/* <Form.Label>Card Number</Form.Label> */}
                  <div id="ccnumber" className={'box-shadow' + (ccnumberInvalid ? ' is-invalid invalid' : '')} />
                  <Form.Control.Feedback type="invalid">
                    {ccnumberInvalidFeedback}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} xs={6} lg={3} controlId="ccexp" className="ccexp mt-2 mt-lg-0">
                  {/* <Form.Label>Expiry</Form.Label> */}
                  <div id="ccexp" className={'box-shadow' + (ccexpInvalid ? ' is-invalid invalid' : '')} />
                  <Form.Control.Feedback type="invalid">
                    {ccexpInvalidFeedback}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} xs={6} lg={3} controlId="cvv" className="cvv mt-2 mt-lg-0">
                  {/* <Form.Label>CVV</Form.Label> */}
                  <div id="cvv" className={'box-shadow' + (cvvInvalid ? ' is-invalid invalid' : '')} />
                  <Form.Control.Feedback type="invalid">
                    {cvvInvalidFeedback}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>

              {/* Payment Section */}
              <Form.Group as={Col} xs={12} className="mt-2 mt-lg-3">
                <Form.Label className="bold-text">Choose Amount To Pay</Form.Label>
                {/* <Form.Control as="select" className="green-text bold-text" onChange={paymentOptionChanged} value={paymentOption}>
                  {quote.reservation.leadCustomerId === payingCustomer?.customerId && !brandSetting.useDepositOnly && (<option value="full">Full Payment -- {`$${fullPaymentPrice.toFixed(2)}`}</option>)}

                  {!brandSetting.useDepositOnly && splitPaymentPrice > 0 && evenCategory !== undefined && (<option value="split">{`${payingCustomer && payingCustomer.paymentAllocationCategory !== undefined ?
                    (`${payingCustomer.paymentAllocationCategoryId === evenCategory.paymentAllocationCategoryId ? "Split" : "Category"}`) : "Split"} Payment`} -- {`$${splitPaymentPrice.toFixed(2)}`}</option>)}
                  {brandSetting.downPayment > 0 && depositPrice > 0 && (<option value="deposit">Deposit Price -- {`$${depositPrice.toFixed(2)}`}</option>)}
                </Form.Control> */}

                {quote.reservation.leadCustomerId === payingCustomer?.customerId && !brandSetting.useDepositOnly && (
                  <Form.Check type="radio" id={`full-option`}>
                    <Form.Check.Input
                      type="radio"
                      style={{ marginTop: "-9px" }}
                      name="paymentOptions"
                      checked={paymentOption === "full"}
                      value="full"
                      onChange={paymentOptionChanged}
                    />
                    <Form.Check.Label>Full Payment -- <span style={{ fontWeight: "bold", color: 'green' }}>{`$${fullPaymentPrice.toFixed(2)}`}</span></Form.Check.Label>
                  </Form.Check>
                )}

                {!brandSetting.useDepositOnly && splitPaymentPrice > 0 && evenCategory !== undefined && (
                  <Form.Check type="radio" id={`split-option`}>
                    <Form.Check.Input
                      type="radio"
                      style={{ marginTop: "-9px" }}
                      name="paymentOptions"
                      checked={paymentOption === "split"}
                      value="split"
                      onChange={paymentOptionChanged}
                    />
                    <Form.Check.Label>{`${payingCustomer && payingCustomer.paymentAllocationCategory !== undefined ?
                      (`${payingCustomer.paymentAllocationCategoryId === evenCategory.paymentAllocationCategoryId ? "Split" : "Category"}`) : "Split"} Payment`} --
                      <span style={{ fontWeight: "bold", color: 'green' }}>{`$${splitPaymentPrice.toFixed(2)}`}</span>
                    </Form.Check.Label>
                  </Form.Check>
                )}

                {brandSetting.downPayment > 0 && depositPrice > 0 && (
                  <Form.Check type="radio" id={`deposit-option`}>
                    <Form.Check.Input
                      type="radio"
                      style={{ marginTop: "-9px" }}
                      name="paymentOptions"
                      checked={paymentOption === "deposit"}
                      value="deposit"
                      onChange={paymentOptionChanged}
                    />
                    <Form.Check.Label>Deposit Price -- <span style={{ fontWeight: "bold", color: 'green' }}>{`$${depositPrice.toFixed(2)}`}</span></Form.Check.Label>
                  </Form.Check>
                )}

              </Form.Group>
            </Col>

            <Col xs={12} lg={6} className="">
              <Form.Group as={Col} xs={12} className="mt-2 mt-lg-0">
                <Form.Label className="bold-text">Apply Payment To</Form.Label>
                <Form.Control as="select" className="box-shadow" onChange={customerSelected}>
                  {props.payingCustomer && (
                    <option value={props.payingCustomer.customerId}>{`${props.payingCustomer.customer.firstName} ${props.payingCustomer.customer.lastName}`}</option>
                  )}

                  {props.payingCustomer == undefined && quote.reservation.reservationCustomers.map(rc => (
                    <>
                      {!rc.cancelled && (
                        <option key={`make payment ${rc.customerId}-${rc.customer.firstName}-${rc.customer.lastName}`} value={rc.customerId}>{`${rc.customer.firstName} ${rc.customer.lastName}`}</option>
                      )}
                    </>)
                  )}
                </Form.Control>
              </Form.Group>

              {/* Tip Section */}
              {brandSetting.allowAgentTips && props.quote.reservation.agent && (
                <>
                  {/* <p className="tip-text mt-3 pt-2">
                    Would you like to add a Tip for your booking agent?
                  </p> */}
                  <Row className="mt-3 justify-content-between">
                    {/* <h6 className="green-text pr-4 pt-2">Optional Agent Tip:</h6> */}
                    <p style={{ marginTop: "12px", fontSize: "12px" }}>Would you like to add a Tip for your booking agent?</p>
                    <Form.Control
                      name="agentTip"
                      ref={register}
                      className="box-shadow other-amount-input text-right"
                      value={agentTip}
                      onChange={(event: any) => onAgentTip(event)}
                    />
                  </Row>
                </>
              )}

              {/* Grand Total */}
              <Row className="d-flex flex-row justify-content-between" style={{ marginTop: "25px" }}>
                <img
                  alt="Digicert"
                  title="Digicert"
                  src="https://pkgloop.com/wp-content/uploads/2022/02/digicert-lock-logo.png"
                  width="auto"
                  height="40px"
                  style={{
                    objectFit: "contain",
                    marginTop: "20px"
                  }}
                />
                <p className="bold-text text-right pt-4" style={{ fontSize: "22px", color: "#cc0000" }}>
                  Total Paying Today: <span className="green-text">{`$${paymentAmount.toFixed(2)}`}</span>
                </p>
              </Row>
            </Col>
          </Row>
        </div>

        {/* Terms & Conditions */}
        <Col className="mb-3 d-flex flex-column justify-content-center text-center">
          <Row className="d-flex flex-row justify-content-center" style={{ marginTop: "20px" }}>
            <Form.Control type="checkBox" name="termsCheck" ref={register} style={{ marginTop: "5px", width: "25px", height: "25px" }}
              isValid={formState.isSubmitted && !errors.termsCheck}
              isInvalid={formState.isSubmitted && (!!errors.termsCheck)}
            />
            <p
              className="widget-font m-0"
              style={{ paddingLeft: "20px", color: "rgb(185,185,185)" }}
            >
              I Agree To The&nbsp;
              <Button className="m-0 p-0" variant="link" onClick={() => setShowTerms(true)}>Terms &amp; Conditions</Button>
            </p>
          </Row>

          <p className="m-0 p-0" style={{ fontSize: "14px", color: "#e24d5c" }}>{errors.termsCheck && errors.termsCheck.message}</p>
        </Col>

        {/* Make Payment Button */}
        <Col style={{ marginTop: "0px" }}>
          <Row className="d-flex flex-direction-row justify-content-center mb-1">
            {/* <div className="g-recaptcha" data-sitekey="6Le1xBwpAAAAABa2yi2VKSNAgtDxv9X16Sfg4xky"></div> */}
            <ReCAPTCHA
              sitekey={"6Le1xBwpAAAAABa2yi2VKSNAgtDxv9X16Sfg4xky"}
              ref={captchaRef}
              onChange={s => setCaptcha(s)}
            />
          </Row>
          <Row>
            <Button
              className="make-payment-button"
              type="submit"
              block
              disabled={paymentAmount <= 0.0 || captcha === null}
              onClick={() => {
                validationCallback("ccnumber", ccNumberValidated, "Required");
                validationCallback("ccexp", ccExpValidated, "Required");
                validationCallback("cvv", cvvValidated, "Required");
               }}
            >
              <Row className="justify-content-center align-items-center">
                {(submitPaymentResponse.isLoading || submitting) && (
                  <Spinner
                    className="mr-2"
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                {(submitPaymentResponse.isLoading || submitting) ? "Paying..." : "Make Payment"}
              </Row>
            </Button>
          </Row>
        </Col>
      </Form>

      <Modal
        size="lg"
        show={showTerms}
        onHide={() => {
          setShowTerms(false);
        }}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow"
      >
        <Modal.Header
          translate
          closeButton
          style={{
            border: "none",
            borderBottom: "1px solid rgb(222,222,222)",
          }}
        >
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold", color: "green" }}
          >
            Terms And Conditions
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Make Payment */}
          {(brandSetting.brand.termsAndConditions !== undefined && brandSetting.brand.termsAndConditions !== null) && parseTerms()}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default MakePayment;